import React from "react";

const SearchBox = ({ searchQuery, handleSearch, toggle=false, mode, setQuery=null}) => {
  return (

      <div class="relative bg-inherit">
        <input
          type="text"
          id="searxhQuery"
          name="searchQuery"
          class="peer bg-white h-11 w-full shadow-md shadow-gray-400 rounded-lg text-gray-700 placeholder-white ring-1 px-2 ring-gray-300 focus:ring-sky-600 focus:outline-none focus:border-rose-600"
          placeholder="Search for keyword"
          value={searchQuery}
          onChange={handleSearch}
          onBlur={() => {
            if(mode!==1){
              setQuery(searchQuery.trim())}
            }
          }
        />
        <label
          for="searxhQuery"
          class="absolute cursor-text left-0 -top-3 text-sm bg-white text-gray-400 bg-inherit mx-1 px-1 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500 peer-placeholder-shown:top-2 peer-focus:-top-3 peer-focus:text-sky-600 peer-focus:text-sm transition-all pointer-events-none"
        >
          {mode===1?"Search for keyword":toggle?"Enter Description" : "Enter Keyword"}
        </label>
 
    </div>
  );
};

export default SearchBox;
